/**
 * ShareType enum
 * Defines the type of content being shared
 * Matches Flutter implementation: lib/data/models/share_info.dart
 */
export enum ShareType {
  user = 0,
  content = 1,
}
